import { RentalType } from '@guiker/rental-listing-shared'

export enum MultipostListingInquiryParser {
  manual = 'scheduledFetch',
  rentsync = 'rentsyncWebhook',
  zillow = 'zillowWebhook',
  costar = 'costarWebhook',
  email = 'sendgridWebhook',
  leadsbridge = 'leadsbridgeWebhook',
  n8n = 'n8nEmailFlow',
}

export enum MultipostListingInquirySource {
  manual = 'manual',
  rentsync = 'rentsync',
  zillow = 'zillow',
  costar = 'costar',
  email = 'email',
  leadsbridge = 'leadsbridge',
  buildium = 'buildium',
}

export type MultipostListingInquiryProcessBatch = {
  inquiryIds: string[]
  inquiryIdsMissedTarget: string[]
  inquiredTargets: {
    inquiryId: string
    parser: string
    source: string
    channel: string
    listingId: number
    optionId?: number
    rentalType?: RentalType
  }[]
  channels: Set<string>
}

export type MultipostListingInquiryStats = {
  listingId: string
  parser: MultipostListingInquiryParser
  count: number
  timestamps: string[]
}

export type MultipostListingInquiry = {
  id?: string
  user: {
    name: string
    firstName?: string
    lastName?: string
    emailAddress?: string
    proxyEmailAddress?: string
    phoneNumber?: string
  }
  channel: string
  originalLink?: string
  rentalType?: RentalType
  parser: MultipostListingInquiryParser
  source: MultipostListingInquirySource
  message?: string
  listingId?: string
  optionId?: string
  emailBody?: string
  inquiredAt: string
  processedAt?: string
  matchedAvailability?: boolean
  postingUrl?: string
  moveInDate?: string
  raw?: unknown
}
